import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useBaseURL } from '../context/BaseURLContext';

export const ProtectedRoute = ({ allowedBaseURL }) => {
    const baseURL = useBaseURL();

    if (baseURL.includes(allowedBaseURL)) {
        return <Outlet />;
    } else {
        return <Navigate to="/" />;
    }
};
